import { render } from "./BonusWinnersView.vue?vue&type=template&id=5b173d5a&scoped=true&ts=true"
import script from "./BonusWinnersView.vue?vue&type=script&lang=ts"
export * from "./BonusWinnersView.vue?vue&type=script&lang=ts"

import "./BonusWinnersView.vue?vue&type=style&index=0&id=5b173d5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b173d5a"]])

export default __exports__